import { Component } from '@angular/core';
import { BlackStatusSampling } from './black-status-sampling/black-status-sampling';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlackStatusPie } from './black-status-pie/black-status-pie';
import { MatDividerModule } from '@angular/material/divider';
import { BlackStatusListView } from './black-status-list-view/black-status-list-view';
import { BlackStatusDuration } from './black-status-duration/black-status-duration';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';
import { DatepickerRange } from '../../widgets/datepicker-range/datepicker-range';
import { MatCardModule } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslatorService } from '../../services/translator_service';
import { ResponsiveService } from '../../services/responsive.service';
import { ApiStore } from '../../web-services/api/api.store';
import { ApiService } from '../../web-services/api/api.service';
import moment from 'moment';

@Component({
  selector: 'app-insights',
  imports: [TranslatePipe,FormsModule,ReactiveFormsModule,CommonModule,MatDividerModule,BlackStatusPie,
    MatCardModule, RTLDivDirectiveDirective,BlackStatusSampling,BlackStatusDuration,BlackStatusListView,
	DatepickerRange],
  templateUrl: './insights.html',
  styleUrl: './insights.scss',
})
export class Insights {
  isMobile: Boolean;
	currentLang;
	translationsObj;
 	showDatePicker: Boolean = false;
	selectedDates: any = {
		from: '',
		to: ''
	};
	minDate = '';
	maxDate = '';
	lastMaxDate:any;
	lastMinDate:any;
	ElForm: FormGroup;
	blackStatusValue:number = 90;
	editBlackStatusFlag:boolean = true;

  constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,
    private apiService:ApiService,private apiStore:ApiStore,private fb: FormBuilder) {
    this.translator.currentLangEmitter$
		.subscribe(async value=>{						
		  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
		  this.currentLang = value;	
		})
		this.ElForm = this.fb.group({
			blackStatusBin :new FormControl(90)
		});
   }

  ngOnInit() {
    this.onResize();
	this.responsiveService.checkWidth();
	sessionStorage.setItem("blackStatusBin","90");
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  submitBlackStatus(){
	if(this.ElForm.getRawValue()['blackStatusBin'] < 50 || this.ElForm.getRawValue()['blackStatusBin'] > 100){
		return;
	}else{
		this.blackStatusValue = this.ElForm.getRawValue()['blackStatusBin'];
		this.editBlackStatusFlag = true;
		sessionStorage.setItem("blackStatusBin",this.ElForm.getRawValue()['blackStatusBin']);
		this.getBinCapacityAnalysis(this.minDate,this.maxDate);		
	}
  }

  editBlackStatus(){
	this.editBlackStatusFlag = false;
  }

  showHideDatePicker = () => {
    this.showDatePicker = !this.showDatePicker;
  }

  onSelectDates = (selectDates: any) => {
	setTimeout(() => {
		this.showDatePicker = false;
		this.selectedDates.from = selectDates.fromDate;
		this.selectedDates.to = selectDates.toDate;		
		this.minDate = moment(this.selectedDates.from, 'DD.MM.YYYY').format('YYYY-MM-DD 00:00:01');
		this.maxDate = moment(this.selectedDates.to, 'DD.MM.YYYY').format('YYYY-MM-DD 23:59:59');
		sessionStorage.setItem("insightsMinDate",this.minDate);
		sessionStorage.setItem("insightsMaxDate",this.maxDate);

		sessionStorage.setItem("insightsStartDate",this.minDate);
		sessionStorage.setItem("insightsEndDate",this.maxDate);

		let collectionsStatsRequest = {
			site_id_list : JSON.parse(sessionStorage.getItem("chosenSites"))?.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
			start_date : this.minDate,
			end_date : this.maxDate
		}

		if(this.maxDate != this.lastMaxDate || this.minDate != this.lastMinDate){
 			this.getBinCapacityAnalysis(this.minDate,this.maxDate);	
			this.apiStore.update({ CollectionsStatsForInsights: [] });	
			this.apiService.getfilteredBinsCollectionsStats(collectionsStatsRequest,4,JSON.parse(sessionStorage.getItem("chosenSites")))
		}
	}, 0);		
  }

  getBinCapacityAnalysis(start,end){
	let requestWorkPlanAnalysis = {
		sites_list : [],
		capacity_in_percent :this.ElForm.getRawValue()['blackStatusBin'],
		start_date : start,
		end_date : end
	}
	this.apiStore.update({ allBinCapacityAnalysis: [] });
	this.apiStore.update({ binCapacityAnalysis: [] });
	this.apiService.getWorkPlanAnalysis(requestWorkPlanAnalysis,JSON.parse(sessionStorage.getItem("chosenSites")));
	this.lastMinDate = start;
	this.lastMaxDate = end;
  }
}
